export const changePolicystartDateReducer = (state = '', action) => {
  switch (action.type) {
    case "CHANGE_PolicystartDate":
      return action.payload.PolicystartDate;
    default:
      return state;
  }
};
